import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
  popover: {
    pointerEvents: 'none'
  },
  children: {
    display: 'inline',
    '&:hover': {
      cursor: 'pointer'
    }
  },
  listContainer: {
    backgroundColor: '#000000'
  }
});
